import { osloDateString } from "@/lib/oslo-time";
import { weekStart } from "@/lib/lead-stats-calc";
import type { CustomerActivityStatus, CustomerActivityType } from "@/lib/db-types";

/** Kontakt med kunden: e-post, samtale og SMS ut. Referater, notater og møter teller ikke. */
export const CONTACT_ACTIVITY_TYPES: readonly CustomerActivityType[] = ["email_out", "call", "sms_out"];
/** Planlagte, feilede og kansellerte utsendinger er ikke en kontakt ennå. */
export const NOT_A_CONTACT_STATUSES: readonly CustomerActivityStatus[] = ["scheduled", "failed", "cancelled"];

export interface ContactCounts {
  today: number;
  week: number;
}

/**
 * Kontakter i dag og denne uken (mandag til i dag, norsk tid), fra kundeaktivitetene
 * og leadsamtalene. Aktivitetene er allerede filtrert på type, status og bruker.
 */
export function countContacts(
  activities: readonly { occurred_at: string }[],
  leadCalls: { today: number; week: number },
  now: Date,
): ContactCounts {
  const today = osloDateString(now);
  const week = weekStart(today);
  let todayCount = 0;
  let weekCount = 0;
  for (const a of activities) {
    const day = osloDateString(a.occurred_at);
    if (day === today) todayCount++;
    if (day >= week && day <= today) weekCount++;
  }
  return { today: todayCount + leadCalls.today, week: weekCount + leadCalls.week };
}
